window.Branch = window.Branch || {};
window.Branch.cart = window.Branch.cart || {};

window.Branch.cart.checkForMismatchedProducts = function(item, compatibleWithArray, type){
    let addOnVariantMatches = JSON.parse(document.querySelector(`#addon-variant-matches`).innerText);
    let mismatched = true;
    let productOptions = item.getAttribute('data-options').split(",");
    let productOptionValues = item.getAttribute('data-option-values').split(",");
    let itemHandle = item.getAttribute('data-product-handle');

        let findIndex = function(arr, targetValue) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === targetValue) {
                    return i;
                }
            }
            // If the value is not found, return -1
            return -1;
        }
        compatibleWithArray.forEach((compatibleHandle) => {
        let variantMatches = undefined;
        let productExistsInAddOnVariantMatches = false;
        let optionsWithNoMatching = undefined;
        for (const [handle, matchData] of Object.entries(addOnVariantMatches)) {
            if(compatibleHandle === handle){
            matchData.forEach((matchDataEntry) => {
                if(itemHandle === matchDataEntry['add-on-handle']){
                    variantMatches = matchDataEntry['variant-matches'];
                    productExistsInAddOnVariantMatches = true;
                    optionsWithNoMatching = matchDataEntry['options_with_no_matching'] ? matchDataEntry['options_with_no_matching'] : []
                }
            })
            }
        }

        if(productExistsInAddOnVariantMatches == false){
            mismatched = false;
        } else {
            mismatched = true;
        }

        if(variantMatches && mismatched == true){
            let matchesFullfilled = 0;
            let nonCompulsoryMatchConditions = 0;
            let nonCompulsoryMatchConditionsMet = false;

            variantMatches.forEach((variantMatch) => {
                if(variantMatch['match-not-required-if-other-options-match'] == true) {
                    nonCompulsoryMatchConditions = nonCompulsoryMatchConditions + 1;
                }
            });

            variantMatches.forEach((variantMatch) => {
                if(variantMatch['non-compulsory-match'] == true){
                    matchesFullfilled = matchesFullfilled + 1
                } else {
                    productOptions.forEach((productOption, index) => {
                        if(variantMatch['add-on-option-name'].toLowerCase().replaceAll(' ', '-') == productOption ){
                        let value = item.querySelector('.variants').getAttribute(`${productOption}`);
                       
                        let variantsIdArray = [];
                        let compatibleItems = type == "side-cart" ? document.querySelectorAll(`#side-cart .cart-items .item[data-product-handle="${compatibleHandle}"]`) : document.querySelectorAll(`#cart #cartform .items .item[data-product-handle="${compatibleHandle}"]`); 
                        compatibleItems.forEach((compatibleItem) => {
                            if(!variantsIdArray.includes(compatibleItem.getAttribute('data-variant-id'))){
                                let valueFromVariantsElement = compatibleItem.querySelector('.variants').getAttribute(`${variantMatch['option-name'].toLowerCase().replaceAll(' ', '-')}`);
                                                            
                                let matchValue = valueFromVariantsElement;
                                if(variantMatch['non-identical-values-to-match'] && variantMatch['non-identical-values-to-match'].length > 0){
                                    let optionIndex = findIndex(productOptions, productOption);
                                    let productOptionValue = productOptionValues[`${optionIndex}`].replaceAll('@', ',')
                                    variantMatch['non-identical-values-to-match'].forEach((nonIdenticalMatch) => {
                                        if(nonIdenticalMatch['value'] == valueFromVariantsElement && nonIdenticalMatch['add-on-value'] == productOptionValue){
                                            matchValue = nonIdenticalMatch['add-on-value'];
                                            matchesFullfilled = matchesFullfilled + 1;
                                        }
                                    })
                                }

                                else if(value === matchValue){
                                    if(variantMatch['match-not-required-if-other-options-match'] == true && nonCompulsoryMatchConditionsMet == false){
                                        matchesFullfilled = matchesFullfilled + nonCompulsoryMatchConditions;
                                        nonCompulsoryMatchConditionsMet = true;
                                    } else if(!variantMatch['match-not-required-if-other-options-match']) {
                                        matchesFullfilled = matchesFullfilled + 1;
                                    }
                                } 

                                variantsIdArray.push(compatibleItem.getAttribute('data-variant-id'));
                            }
                        });
                    }
                })
            }
        })


        if(matchesFullfilled >= variantMatches.length){
            mismatched = false;
        }

        if(optionsWithNoMatching.length > 0){
            let compatibleItems = type == "side-cart" ? document.querySelectorAll(`#side-cart .cart-items .item[data-product-handle="${compatibleHandle}"]`) : document.querySelectorAll(`#cart #cartform .items .item[data-product-handle="${compatibleHandle}"]`); 
            compatibleItems.forEach((compatibleItem) => {
                const attributesArray = [...compatibleItem.querySelector('.variants').attributes]
                    .filter(attr => attr.name.toLowerCase() !== 'class')
                    .map(attr => ({ [attr.name.replaceAll(' ', '-').toLowerCase()]: attr.value.replaceAll(' ', '-').toLowerCase() }));

                attributesArray.forEach((attribute) => {
                    const [key, value] = Object.entries(attribute)[0];
                    optionsWithNoMatching.forEach((optionWithNoMatching) => {
                        if(key == optionWithNoMatching['option-name'].replaceAll(' ', '-').toLowerCase() && value == optionWithNoMatching['option-value'].replaceAll(' ', '-').toLowerCase()){
                            if(optionWithNoMatching['addon-option-name'] && optionWithNoMatching['addon-option-value']){
                                const addonAttributesArray = [...item.querySelector('.variants').attributes]
                                .filter(attr => attr.name.toLowerCase() !== 'class')
                                .map(attr => ({ [attr.name.replaceAll(' ', '-').toLowerCase()]: attr.value.replaceAll(' ', '-').toLowerCase() }));
                                addonAttributesArray.forEach((addonAttribute) => {
                                    const [key, value] = Object.entries(addonAttribute)[0];
                                    if(key == optionWithNoMatching['addon-option-name'].replaceAll(' ', '-').toLowerCase() && value == optionWithNoMatching['addon-option-value'].replaceAll(' ', '-').toLowerCase()){
                                        mismatched = true;
                                    }
                                })
                            } else {
                                mismatched = true;
                            }
                        }
                    })
                })
            })
        }

        // console.log('mismatched', mismatched, 'matchesFullfilled', matchesFullfilled, 'variantMatches.length', variantMatches.length)
 
        if(mismatched){
            let mismatchedHTML = `<div class="${type == 'side-cart' ? 'side-cart' : 'cart-page'}-incompatible-warning-container"><svg aria-hidden="true" tabindex="-1" role="presentation" class=" icon icon-exclamation-mark-circle" viewBox="0 0 32 32"><circle cx="16.2521" cy="16.5881" r="16" fill="#A72100"></circle><path fill="white" d="M16.2679 19.7261C15.7692 19.7261 15.4979 19.4474 15.4539 18.8901L14.8159 10.7941C14.7865 10.3394 14.9039 9.95807 15.1679 9.65007C15.4465 9.34207 15.8059 9.18807 16.2459 9.18807C16.6859 9.18807 17.0452 9.34207 17.3239 9.65007C17.6025 9.95807 17.7199 10.3394 17.6759 10.7941L17.0599 18.8901C17.0159 19.4474 16.7519 19.7261 16.2679 19.7261ZM16.1139 24.5881C15.6885 24.5881 15.3585 24.4781 15.1239 24.2581C14.9039 24.0234 14.7939 23.6934 14.7939 23.2681V22.8941C14.7939 22.4687 14.9039 22.1461 15.1239 21.9261C15.3585 21.6914 15.6885 21.5741 16.1139 21.5741H16.3999C16.8252 21.5741 17.1479 21.6914 17.3679 21.9261C17.6025 22.1461 17.7199 22.4687 17.7199 22.8941V23.2681C17.7199 23.6934 17.6025 24.0234 17.3679 24.2581C17.1479 24.4781 16.8252 24.5881 16.3999 24.5881H16.1139Z"></path></svg> <p>&nbsp; &nbsp; &nbsp;<strong>Are you sure?</strong> This add-on color/size doesn't match with the other products in your cart.</p></div>`;
            let warningContainer = type == 'side-cart' ? item.querySelector('.grid__item.two-thirds') : item.querySelector('.variants-edit-wrap') 
            
            /* Remove all previously existing HTML */
            warningContainer.querySelectorAll(`.${type == 'side-cart' ? 'side-cart' : 'cart-page'}-incompatible-warning-container`).forEach((existingHTML) => {
                existingHTML.remove();
            })
            
            warningContainer.insertAdjacentHTML('beforeend', mismatchedHTML);
        }
    }
    });
    
}


window.Branch.cart.incompatibleProducts = function(cartContents, type){
    let productHandles = [];
    if(cartContents.length > 0){
    cartContents.forEach((cartContent) => {
        productHandles.push(cartContent.handle);
    })
    }
    
    let items = type == 'side-cart' ? document.querySelectorAll('#side-cart .cart-items .item') : document.querySelectorAll('#cart #cartform .items .item');
    items.forEach((item) => {
    if(item.getAttribute('data-compatible-with') && item.getAttribute('data-compatible-with') != ''){
        let itemInCategoryExists  = false;
        if(item.getAttribute('data-category-specified') && item.getAttribute('data-category-specified') != ''){
            let category = item.getAttribute('data-category-specified');
            items.forEach((itemForCategory) => {
                if(itemForCategory.getAttribute('data-variant-id') !== item.getAttribute('data-variant-id')){
                    if(category == itemForCategory.getAttribute('data-product-type') 
                        || category == "open box chairs" && itemForCategory.getAttribute('data-product-type') == "office chairs"
                        || category == "open box desks" && itemForCategory.getAttribute('data-product-type') == "desks"){
                        itemInCategoryExists = true;
                    }
                }
            })
        } else {
            itemInCategoryExists  = true;
        }

        // console.log('itemInCategoryExists', itemInCategoryExists)

        if(itemInCategoryExists){
            let compatibleWithArray = item.getAttribute('data-compatible-with').split(",");
            let showWarning = true;
            productHandles.forEach((productHandle) => {
            compatibleWithArray.forEach((compatibleWithHandle) => {
                if(productHandle === compatibleWithHandle){
                showWarning = false;
                }
            })
            });

            if(showWarning){
            let warningContainer = type == 'side-cart' ? item.querySelector('.grid__item.two-thirds') : item.querySelector('.variants-edit-wrap') 
            let warningHTML = `<div class="${type == 'side-cart' ? 'side-cart' : 'cart-page'}-incompatible-warning-container"><svg aria-hidden="true" tabindex="-1" role="presentation" class=" icon icon-exclamation-mark-circle" viewBox="0 0 32 32"><circle cx="16.2521" cy="16.5881" r="16" fill="#A72100"></circle><path fill="white" d="M16.2679 19.7261C15.7692 19.7261 15.4979 19.4474 15.4539 18.8901L14.8159 10.7941C14.7865 10.3394 14.9039 9.95807 15.1679 9.65007C15.4465 9.34207 15.8059 9.18807 16.2459 9.18807C16.6859 9.18807 17.0452 9.34207 17.3239 9.65007C17.6025 9.95807 17.7199 10.3394 17.6759 10.7941L17.0599 18.8901C17.0159 19.4474 16.7519 19.7261 16.2679 19.7261ZM16.1139 24.5881C15.6885 24.5881 15.3585 24.4781 15.1239 24.2581C14.9039 24.0234 14.7939 23.6934 14.7939 23.2681V22.8941C14.7939 22.4687 14.9039 22.1461 15.1239 21.9261C15.3585 21.6914 15.6885 21.5741 16.1139 21.5741H16.3999C16.8252 21.5741 17.1479 21.6914 17.3679 21.9261C17.6025 22.1461 17.7199 22.4687 17.7199 22.8941V23.2681C17.7199 23.6934 17.6025 24.0234 17.3679 24.2581C17.1479 24.4781 16.8252 24.5881 16.3999 24.5881H16.1139Z"></path></svg> <p>&nbsp; &nbsp; &nbsp;<strong>Are you sure?</strong> This add-on isn’t compatible with the other products in your cart.</p></div>`;
            warningContainer.insertAdjacentHTML('beforeend', warningHTML);
            } else {
                window.Branch.cart.checkForMismatchedProducts(item, compatibleWithArray, type);
            }
        }
    }
    })
}

window.Branch.cart.insertSpecialIncompatibleWarning = function(cartItem, cartWarning, type){
    let cartItemsToInsert = type == "side-cart" ? document.querySelectorAll(`#side-cart .cart-items .item[data-product-handle="${cartItem.handle}"]`) : document.querySelectorAll(`#cart #cartform .items .item[data-product-handle="${cartItem.handle}"]`); 
    let warningHTML = `<div class="${type == 'side-cart' ? 'side-cart' : 'cart-page'}-special-incompatible-warning-container"><svg aria-hidden="true" tabindex="-1" role="presentation" class=" icon icon-exclamation-mark-circle" viewBox="0 0 32 32"><circle cx="16.2521" cy="16.5881" r="16" fill="#A72100"></circle><path fill="white" d="M16.2679 19.7261C15.7692 19.7261 15.4979 19.4474 15.4539 18.8901L14.8159 10.7941C14.7865 10.3394 14.9039 9.95807 15.1679 9.65007C15.4465 9.34207 15.8059 9.18807 16.2459 9.18807C16.6859 9.18807 17.0452 9.34207 17.3239 9.65007C17.6025 9.95807 17.7199 10.3394 17.6759 10.7941L17.0599 18.8901C17.0159 19.4474 16.7519 19.7261 16.2679 19.7261ZM16.1139 24.5881C15.6885 24.5881 15.3585 24.4781 15.1239 24.2581C14.9039 24.0234 14.7939 23.6934 14.7939 23.2681V22.8941C14.7939 22.4687 14.9039 22.1461 15.1239 21.9261C15.3585 21.6914 15.6885 21.5741 16.1139 21.5741H16.3999C16.8252 21.5741 17.1479 21.6914 17.3679 21.9261C17.6025 22.1461 17.7199 22.4687 17.7199 22.8941V23.2681C17.7199 23.6934 17.6025 24.0234 17.3679 24.2581C17.1479 24.4781 16.8252 24.5881 16.3999 24.5881H16.1139Z"></path></svg>${cartWarning.replaceAll('`', '"').replaceAll('<p>', '<p>&nbsp; &nbsp; &nbsp;')}</div>`;
    if(cartItemsToInsert.length > 0){
        
        cartItemsToInsert.forEach((cartElement) => {
            let warningContainer = type == 'side-cart' ? cartElement.querySelector('.grid__item.two-thirds') : cartElement.querySelector('.variants-edit-wrap') 
            warningContainer.insertAdjacentHTML('beforeend', warningHTML);
        })
    }
    }


const returnCompatibleProductInCart = function(cartContents, compatibleProducts){
    let compatibleProductInCart = false;
    if(compatibleProducts.length > 0){
        compatibleProducts.forEach((compatibleProductHandle) => {
            cartContents.forEach((cartContent) => {
                if(cartContent.handle == compatibleProductHandle){
                    compatibleProductInCart = true;
                }
            })
        })
    }
    return compatibleProductInCart;
}

const returnWarning = function(cartItem, specialIncompatibleWarningData, cartContents){
    let warning;
    let dataEntry = specialIncompatibleWarningData[`${cartItem.handle}`];
    if(dataEntry){
        let compatibleProductInCart = returnCompatibleProductInCart(cartContents, dataEntry['compatible_products'])
        if(compatibleProductInCart == false){
            warning = dataEntry['rich_text'];
        }
    }
    return warning;
}

window.Branch.cart.numberOfSlotsWarning = function(cartContents, type, slotData){
    
    /* Condense cart contents into single-product objects so that the data isn't counted twice */
    let condensedCartContents = cartContents.reduce((acc, item) => {
        const existingItem = acc.find(subItem => subItem.handle === item.handle);
        if (existingItem) {
          existingItem.quantity += item.quantity;
        } else {
          acc.push({ handle: item.handle, quantity: item.quantity });
        }
        return acc;
    }, []);


    let totalSlots = 0;
    let totalSlotsOccupied = 0;
    let allSlotAccessories = {};
    let selector = '';
    let warningClassName = type == 'side-cart' ? 'side-cart-slot-warning-container' : 'cart-page-slot-warning-container';

    /* Count the total number of available slots */
    condensedCartContents.forEach((condensedCartItem) => {
        let cartContentSlotData = slotData[`${condensedCartItem.handle}`];
        
        if(cartContentSlotData){
            totalSlots = totalSlots + (cartContentSlotData[`parent-slots`] * condensedCartItem.quantity);
            for (const [key, value] of Object.entries(cartContentSlotData[`accessories`])) {
                allSlotAccessories[`${key}`] = value
            }
        }
    });

    /* Count the total number of occupied slots */
    cartContents.reverse().forEach((cartItem) => {
        let cartItemSlotData = allSlotAccessories[`${cartItem.handle}`];
        if(cartItemSlotData){
            let slotsTakenUp = cartItemSlotData[`default-slots-occupied`];
            if(cartItemSlotData[`variant-level-slot-data`] && cartItemSlotData[`variant-level-slot-data`][`${cartItem.variant_id}`]){
                slotsTakenUp = cartItemSlotData[`variant-level-slot-data`][`${cartItem.variant_id}`];
            }
            slotsTakenUp = slotsTakenUp * cartItem.quantity;
            totalSlotsOccupied = totalSlotsOccupied + slotsTakenUp;

            /* if totalSlotsOccupied exceeds totalSlots, add a selectot for the respective cart item to the selector variable */
            if(totalSlotsOccupied > totalSlots){
                if(type == 'side-cart'){
                    selector = `${selector}, #side-cart .cart-items .item[data-product-handle="${cartItem.handle}"][data-key="${cartItem.key}"]`
                } else {
                    selector = `${selector}, #cart .items .item[data-product-handle="${cartItem.handle}"][data-key="${cartItem.key}"]`
                }
            }
        }
    });

    selector = selector.replace(',', '');

    /* Remove all existing slot warnings */
    document.querySelectorAll(`.${warningClassName}`).forEach((slotWarning) => {
        slotWarning.remove();
    });

    /* if totalSlotsOccupied exceeds totalSlots, select the overhanging line items and attached the warning to them */
    if(totalSlotsOccupied > totalSlots){
        let allItemsToAttachWarningTo = document.querySelectorAll(`${selector}`);
        let warningHTML = `<div class="${warningClassName}"><svg aria-hidden="true" tabindex="-1" role="presentation" class=" icon icon-exclamation-mark-circle" viewBox="0 0 32 32"><circle cx="16.2521" cy="16.5881" r="16" fill="#A72100"></circle><path fill="white" d="M16.2679 19.7261C15.7692 19.7261 15.4979 19.4474 15.4539 18.8901L14.8159 10.7941C14.7865 10.3394 14.9039 9.95807 15.1679 9.65007C15.4465 9.34207 15.8059 9.18807 16.2459 9.18807C16.6859 9.18807 17.0452 9.34207 17.3239 9.65007C17.6025 9.95807 17.7199 10.3394 17.6759 10.7941L17.0599 18.8901C17.0159 19.4474 16.7519 19.7261 16.2679 19.7261ZM16.1139 24.5881C15.6885 24.5881 15.3585 24.4781 15.1239 24.2581C14.9039 24.0234 14.7939 23.6934 14.7939 23.2681V22.8941C14.7939 22.4687 14.9039 22.1461 15.1239 21.9261C15.3585 21.6914 15.6885 21.5741 16.1139 21.5741H16.3999C16.8252 21.5741 17.1479 21.6914 17.3679 21.9261C17.6025 22.1461 17.7199 22.4687 17.7199 22.8941V23.2681C17.7199 23.6934 17.6025 24.0234 17.3679 24.2581C17.1479 24.4781 16.8252 24.5881 16.3999 24.5881H16.1139Z"></path></svg> <p>&nbsp; &nbsp; &nbsp; This exceeds the number of accessory inserts available on your Branch desk. It may not fit in addition to the other accessories chosen.</p></div>`

        allItemsToAttachWarningTo.forEach((attachItem) => {
            let warningContainer = type == 'side-cart' ? attachItem.querySelector('.grid__item.two-thirds') : attachItem.querySelector('.variants-edit-wrap') 
            warningContainer.insertAdjacentHTML('beforeend', warningHTML);
        })
    }
}

window.Branch.cart.specialIncompatibleWarning = function(cartContents, type) {
    let specialIncompatibleWarningDataObject = document.querySelector('#special-compatibility-warnings');
    if(specialIncompatibleWarningDataObject){
        let specialIncompatibleWarningData = JSON.parse(document.querySelector(`#special-compatibility-warnings`).innerText);
        if(cartContents.length > 0  && Object.keys(specialIncompatibleWarningData).length > 0){
            cartContents.forEach((cartItem) => {
                let cartWarning = returnWarning(cartItem, specialIncompatibleWarningData, cartContents);
                if(cartWarning){
                    window.Branch.cart.insertSpecialIncompatibleWarning(cartItem, cartWarning, type)
                }
            })
        }
    }
}

window.Branch.cart.productWarnings = function(cartContents, type){
    if(cartContents.length > 0){
        if(cartContents.length > 1){
            let warningContainers = type == 'side-cart' ? document.querySelectorAll('.side-cart-incompatible-warning-container') : document.querySelectorAll('.cart-page-incompatible-warning-container');

            if(warningContainers.length > 0){
                warningContainers.forEach(warningContainer => {
                    warningContainer.remove();
                });
            }
            window.Branch.cart.incompatibleProducts(cartContents, type);
        }

        let specialWarningContainers = type == 'side-cart' ? document.querySelectorAll('.side-cart-special-incompatible-warning-container') : document.querySelectorAll('.cart-page-special-incompatible-warning-container');
        if(specialWarningContainers.length > 0){
            specialWarningContainers.forEach(specialWarningContainer => {
                specialWarningContainer.remove();
            });
        }
        window.Branch.cart.specialIncompatibleWarning(cartContents, type);

        if(document.querySelector('#cart-slot-data')){
            window.Branch.cart.numberOfSlotsWarning(cartContents, type, JSON.parse(document.querySelector('#cart-slot-data').innerText))
        }
    }
}
